import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as Alert } from './Alert.vue';
export { default as AlertDescription } from './AlertDescription.vue';
export { default as AlertTitle } from './AlertTitle.vue';

export const alertVariants = cva(
  'relative w-full rounded-sm border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current',
  {
    defaultVariants: {
      size: 'default',
      variant: 'default',
    },
    variants: {
      size: {
        default: 'text-sm *:[[class*="fa-"]]:not([class*="fa-stack"]):text-sm',
        xs: 'text-xs *:[[class*="fa-"]]:not([class*="fa-stack"]):text-xs',
      },
      variant: {
        accent: 'bg-accent text-accent-foreground *:[[class*="fa-"]]:text-accent-foreground',
        agent: 'bg-agent-muted text-agent-hover',
        default: 'bg-card text-card-foreground border-border',
        destructive:
          'text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive',
        outline: 'border-foreground bg-card text-muted-foreground',
        primary:
          'border-primary-muted bg-primary-muted text-muted-foreground [&>svg]:text-current *:data-[slot=alert-description]:text-primary',
        secondary: 'bg-secondary-muted text-muted-foreground',
        success: 'border-success bg-success-muted text-success',
        neutral: 'border-border bg-muted text-muted-foreground',
        warning:
          'border-warning bg-warning-muted *:data-[slot=alert-description]:text-warning-foreground *:[[class*="fa-"]]:text-warning',
      },
    },
  },
);

export type AlertVariants = VariantProps<typeof alertVariants>;
